<template>
  <b-modal
    id="destroy-creative-modal"
    :modal-class="'default-modal'"
    :hide-footer="true"
  >
    <div class="text-center mt-3">
      <div class="mb-4">
        <i class="fa fa-warning font-size-large text-warning"></i>
      </div>
      <h2 class="">
        <span>{{ $t('delete_creative') }}</span>
      </h2>
      <p v-html="$t('are_you_sure_you_want_to_remove_the_creative', {name: creative ? creative.name : ''})"></p>
      <Button
        type="button"
        class="btn btn-color10 mt-4"
        @click="click"
      >
        {{ $t('remove') }}
      </Button>
    </div>
  </b-modal>
</template>

<script>

import Button from '@/components/common/Button/Button'

export default {
  name: 'DestroyCreativeModal',
  props: ['creative'],
  components: {
    Button
  },
  methods: {
    /**
     * Submit
     */
    async click () {
      this.$bvModal.hide('destroy-creative-modal')
      this.$emit('creative-destroyed', this.creative)
    }
  }
}
</script>
